import { Box, Button, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        The page you’re looking for doesn’t exist or was moved.
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center">
        <Button variant="contained" onClick={() => navigate('/')}>Go to Mailbox</Button>
        <Button variant="outlined" onClick={() => navigate('/settings')}>Open Settings</Button>
      </Stack>
    </Box>
  );
}

